<template>
  <section class="section1">
    <CommonHeader is-light />
    <section class="tw-container tw-mx-auto">
      <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-6">
        <div class="tw-basis-full lg:tw-basis-1/2 tw-flex tw-flex-col tw-justify-center tw-pb-0 md:tw-pb-6 xl:tw-pb-16 2xl:tw-pb-32">
          <div class="wow tw-relative tw-z-20">
            <h3
              class="tw-text-3xl lg:tw-text-5xl xl:tw-text-6xl tw-text-primary !tw-leading-normal tw-font-bold tw-mb-0 md:tw-mb-2 lg:tw-mb-4 xl:tw-mb-5"
              >{{ $t('legend-gateway') }}</h3
            >
            <h4 class="tw-text-3xl lg:tw-text-4xl !tw-font-bold !tw-leading-normal tw-text-white">{{
              $t('embed-banking-into-your-customer-crypto-experience')
            }}</h4>
          </div>
          <div
            class="tw-relative tw-z-20 tw-justify-between tw-items-center tw-hidden lg:tw-flex tw-mt-14 md:tw-mt-18 lg:tw-mt-24 xl:tw-mt-28"
          >
            <div class="tw-mr-8 wow fadeInUp tw-flex-none" data-wow-delay="0.6s">
              <UIButton theme="secondary-3" @click="onTouched" class="tw-btn-lg md:tw-btn-xl tw-uppercase">
                {{ $t('get-in-touch') }} <template #append-inner><svgo-common-arrow-white class="tw-w-2" /> </template
              ></UIButton>
            </div>
            <div
              class="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-w-full tw-h-[60px] tw-py-3 wow fadeInUp"
              data-wow-delay="1.2s"
            >
              <SvgoCommonVisa class="tw-h-full tw-w-24 tw-flex-none" />
              <SvgoCommonMastercard class="tw-h-full" />
              <SvgoCommonSwift class="tw-h-full" />
              <SvgoCommonAch class="tw-h-full" />
              <SvgoCommonSepa class="tw-h-full" />
              <SvgoCommonFaster class="tw-h-full" />
            </div>
          </div>
        </div>
        <div class="tw-basis-full lg:tw-basis-1/2">
          <div class="tw-w-full tw-h-full tw-flex tw-justify-center lg:tw-justify-end tw-relative tw-z-10">
            <div class="tw-basis-7/12 lg:tw-basis-8/12 xl:tw-basis-9/12 tw-relative tw-max-w-[400px]">
              <NuxtImg src="/res/img/infrastructure/iphone-bg-1.png" class="tw-overflow-visible" />
              <NuxtImg class="tw-absolute tw-w-10/12 tw-top-1/4 -tw-left-1/3" alt="buy-now" src="/res/img/infrastructure/buy-now.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="tw-pb-14 lg:tw-hidden tw-relative tw-z-10">
        <div class="tw-mr-10 wow fadeInUp" data-wow-delay="0.6s">
          <UIButton theme="secondary-3" class="tw-btn-lg md:tw-btn-xl tw-uppercase" @click="onTouched"> {{ $t('get-in-touch') }} </UIButton>
        </div>
        <div class="tw-flex tw-justify-around tw-items-center tw-gap-3 tw-w-full tw-mt-10 wow fadeInUp tw-h-5" data-wow-delay="1.2s">
          <SvgoCommonVisa class="tw-h-full tw-w-14 tw-flex-none" />
          <SvgoCommonMastercard />
          <SvgoCommonSwift />
          <SvgoCommonAch />
          <SvgoCommonSepa />
          <SvgoCommonFaster />
        </div>
      </div>
    </section>
    <div class="tw-hidden lg:tw-flex tw-justify-center tw-absolute tw-bottom-14 tw-left-0 tw-w-full">
      <div class="arrow" @click="scrollToView">
        {{ $t('scroll-down') }}
        <SvgoCommonArrowWhite class="tw-w-2 tw-h-4 tw-rotate-90 tw-ml-4" />
      </div>
    </div>
  </section>

  <section class="tw-flex tw-flex-col tw-gap-14 md:tw-gap-18 lg:tw-gap-20 xl:tw-gap-24 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24">
    <section class="section2 tw-container tw-mx-auto" ref="potential">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-px-6 md:tw-px-8 lg:tw-px-10 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 tw-bg-[#111224]/[.02]">
        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-5">
          <div class="tw-flex tw-flex-col tw-justify-center">
            <h3 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold !tw-leading-normal">
              {{ $t('unlock-your-growth-potential-with-legend-gateway') }}
            </h3>
            <div class="tw-text-base md:tw-text-lg lg:tw-text-xl tw-mt-5 md:tw-mt-8 lg:tw-mt-10 xl:tw-mt-14 !tw-leading-normal">
              {{
                $t(
                  'effortlessly-buy-sell-crypto-with-legend-gateways-seamless-fiat-to-crypto-gateway-at-competitive-pricing-and-with-diverse-payment-options',
                )
              }}
            </div>
            <div
              class="tw-text-base tw-text-primary tw-underline tw-flex tw-items-center tw-mt-5 tw-font-bold tw-cursor-pointer"
              @click="onTouched"
            >
              {{ $t('try-legend-gateway-now') }}
              <SvgoCommonArrow class="tw-w-2 tw-h-3 tw-ml-4" />
            </div>
          </div>
          <div class="lg:tw-order-first">
            <div class="tw-w-full chart">
              <div class="tw-mx-auto" id="lottie_box" ref="lottie_box"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section3 tw-container tw-mx-auto">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-py-0 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 lg:tw-bg-[#111224]/[.02]">
        <div class="tw-max-w-screen-xl tw-mx-auto tw-flex tw-flex-col lg:tw-flex-row tw-flex-wrap tw-gap-y-5">
          <div class="tw-order-1 tw-basis-1/4">
            <h5 class="tw-text-lg lg:tw-text-base tw-text-accent/50">{{ $t('show-case') }}</h5>
            <NuxtImg
              alt="logo"
              class="tw-mt-2 md:tw-mt-3 lg:tw-mt-4 xl:tw-mt-5 tw-w-[214px]"
              src="/res/logo-partners/Exchanges Wallets/Kucoin.png"
            />
          </div>
          <div class="tw-order-3 lg:tw-order-2 tw-basis-3/4">
            <div class="tw-text-base md:tw-text-lg lg:tw-text-xl !tw-leading-normal">
              <strong class="tw-font-bold">KUCOIN</strong>
              {{
                $t(
                  'the-integration-with-legend-trading-allows-kucoin-users-to-trade-cryptocurrencies-with-fast-fiat-settlements-legends-proprietary-trading-technology-unlocks-seamless-price-discovery-and-best-trade',
                )
              }}
            </div>
            <div class="tw-mt-10 lg:tw-mt-8">
              <UIButton to="/cases/kucoin" theme="secondary-1" class="tw-btn-lg md:tw-btn-xl tw-uppercase">
                {{ $t('see-full-case') }} <template #append-inner><svgo-common-arrow-white class="tw-w-2" /> </template
              ></UIButton>
            </div>
          </div>

          <div class="tw-order-2 tw-basis-full -tw-mr-5">
            <!-- <div class="tw-relative tw-w-full tw-h-[610px] desktop"> </div>
            <div class="tw-hidden lg:tw-block tw-flex-none tw-w-[260px]">
              <NuxtImg alt="case-desktop" src="/res/img/cases/kucoin-mobile-1.png" />
            </div> -->
            <div class="tw-h-[400px] lg:tw-h-[600px] tw-flex tw-justify-center tw-items-center">
              <div class="tw-basis-0 lg:tw-basis-3/4">
                <NuxtImg alt="case-desktop" src="/res/img/cases/kucoin-desktop.png" />
              </div>
              <div class="tw-basis-0 lg:tw-basis-1/4">
                <NuxtImg alt="case-desktop" src="/res/img/cases/kucoin-mobile-1.png" />
              </div>
              <div class="tw-basis-full tw-h-full lg:tw-basis-0 tw-bg-cover lg:tw-bg-contain desktop">
                <NuxtImg
                  alt="case-desktop"
                  class="tw-w-[180px] tw-bottom-0 tw-absolute lg:tw-hidden"
                  src="/res/img/cases/kucoin-mobile-1.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="tw-container tw-mx-auto">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-px-6 md:tw-px-8 lg:tw-px-10 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 tw-bg-[#111224]/[.02]">
        <div class="tw-flex tw-flex-col lg:tw-flex-row">
          <div class="tw-basis-full lg:tw-basis-1/2 lg:tw-order-2">
            <NuxtImg class="tw-mx-auto" src="/res/img/infrastructure/map.png" />
          </div>
          <div class="tw-basis-full lg:tw-basis-1/2 tw-flex tw-flex-col tw-justify-center">
            <i18n-t
              keypath="global-coverage-accept-all-payment-methods"
              tag="h3"
              class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold"
            >
              <br />
            </i18n-t>
            <p class="tw-text-lg lg:tw-text-xl tw-mt-5 md:tw-mt-6 lg:tw-mt-8 xl:tw-mt-10">
              {{ $t('support-multiple-fiat-currencies-including') }}
            </p>
            <div class="tw-mt-5 md:tw-mt-6 lg:tw-mt-8 xl:tw-mt-10">
              <div class="tw-flex tw-items-center">
                <SvgoCommonIconCheck
                  class="tw-w-4 md:tw-w-5 lg:tw-w-6 tw-h-4 md:tw-h-5 lg:tw-h-6 tw-mr-2 md:tw-mr-3 lg:tw-mr-5 xl:tw-mr-6"
                />
                <i18n-t keypath="support-customers-in" tag="h6" class="tw-text-base md:tw-text-lg lg:tw-text-xl tw-flex-1">
                  <span class="tw-text-primary tw-font-black">150+</span>
                </i18n-t>
              </div>
              <div class="tw-flex tw-items-center tw-mt-2 md:tw-mt-3 lg:tw-mt-4 xl:tw-mt-5">
                <SvgoCommonIconCheck
                  class="tw-w-4 md:tw-w-5 lg:tw-w-6 tw-h-4 md:tw-h-5 lg:tw-h-6 tw-mr-2 md:tw-mr-3 lg:tw-mr-5 xl:tw-mr-6"
                />
                <i18n-t keypath="support-multiple-currencies-including" tag="h6" class="tw-text-base md:tw-text-lg lg:tw-text-xl tw-flex-1">
                  <span class="tw-text-primary tw-font-black">140+</span>
                  <span class="tw-text-primary tw-font-black">USD, EUR, GBP, CHF, AUD, CAD, JPY </span>
                </i18n-t>
              </div>
              <div class="tw-flex tw-items-center tw-mt-2 md:tw-mt-3 lg:tw-mt-4 xl:tw-mt-5">
                <SvgoCommonIconCheck
                  class="tw-w-4 md:tw-w-5 lg:tw-w-6 tw-h-4 md:tw-h-5 lg:tw-h-6 tw-mr-2 md:tw-mr-3 lg:tw-mr-5 xl:tw-mr-6"
                />
                <h6 class="tw-text-base md:tw-text-lg lg:tw-text-xl tw-flex-1">
                  {{ $t('accept-all-major-local-payment-methods') }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section5 tw-container tw-mx-auto">
      <div class="tw-container tw-mx-auto">
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-text-center tw-gap-y-8">
          <div class="tw-basis-full lg:tw-basis-3/12 tw-flex tw-flex-col tw-gap-5">
            <h3 class="tw-text-primary tw-text-6xl lg:tw-text-7xl !tw-font-bold !lg:tw-font-black !tw-leading-none"> 40+ </h3>
            <i18n-t keypath="top-partners" tag="h5" class="tw-text-lg lg:tw-text-xl"> </i18n-t>
          </div>
          <div class="tw-basis-full lg:tw-basis-3/12 tw-flex tw-flex-col tw-gap-5">
            <h3 class="tw-text-primary tw-text-6xl lg:tw-text-7xl !tw-font-bold !lg:tw-font-black !tw-leading-none"> 900+ </h3>
            <h5 class="tw-text-lg lg:tw-text-xl">{{ $t('institutional-clients') }}</h5>
          </div>
          <div class="tw-basis-full lg:tw-basis-3/12 tw-flex tw-flex-col tw-gap-5">
            <h3 class="tw-text-primary tw-text-6xl lg:tw-text-7xl !tw-font-bold !lg:tw-font-black !tw-leading-none"> +150 </h3>
            <h5 class="tw-text-lg lg:tw-text-xl">
              <span class="tw-uppercase">{{ $t('countries') }}</span>
            </h5>
          </div>
          <div class="tw-basis-full lg:tw-basis-3/12 tw-flex tw-flex-col tw-gap-5">
            <h1 class="tw-text-primary tw-text-6xl lg:tw-text-7xl !tw-font-bold !lg:tw-font-black !tw-leading-none">{{
              $t('millions')
            }}</h1>
            <h5 class="tw-text-lg lg:tw-text-xl">{{ $t('retail-investors') }}</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="tw-container tw-mx-auto">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-px-3 md:tw-px-6 lg:tw-px-10 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 tw-bg-[#111224]/[.02]">
        <section class="tw-max-w-screen-xl tw-mx-auto">
          <h4 class="tw-text-center tw-text-xl lg:tw-text-2xl xl:tw-text-3xl !tw-font-bold tw-mx-auto tw-max-w-[600px] !tw-leading-normal">
            {{ $t('legend-gateway-is-honored-to-facilitate-the-success-of-industry-leading-platforms') }}
          </h4>
          <partner-ships-legend-gateway class="tw-mt-7 md:tw-mt-8 lg:tw-mt-10 xl:tw-mt-14" />
        </section>
      </div>
    </section>

    <section class="tw-container tw-mx-auto">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-px-6 md:tw-px-8 lg:tw-px-10 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 tw-bg-[#111224]/[.02]">
        <section class="tw-max-w-screen-xl tw-mx-auto">
          <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between tw-gap-y-5 md:tw-gap-y-6 lg:tw-gap-y-8 xl:tw-gap-y-10">
            <div class="tw-basis-full lg:tw-basis-6/12 tw-flex tw-flex-col tw-gap-y-5 md:tw-gap-y-6 lg:tw-gap-y-8 xl:tw-gap-y-10">
              <i18n-t
                keypath="institutional-grade"
                tag="h3"
                class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold !tw-leading-tight"
              >
                <br />
              </i18n-t>
              <p class="tw-text-base md:tw-text-lg lg:tw-text-xl !tw-leading-normal">
                {{
                  $t(
                    'we-provides-your-users-with-compliant-access-to-the-most-competitive-fiat-to-crypto-pricing-and-deep-liquidity-up-to-20mm-size-for-one-single-trade',
                  )
                }}
              </p>
              <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-3 lg:tw-gap-4 xl:tw-gap-5">
                <div class="tw-flex tw-items-center tw-text-base md:tw-text-lg lg:tw-text-xl">
                  <SvgoCommonIconPig
                    class="tw-w-4 md:tw-w-5 lg:tw-w-6 tw-h-4 md:tw-h-5 lg:tw-h-6 tw-mr-2 md:tw-mr-3 lg:tw-mr-5 xl:tw-mr-6"
                  />
                  {{ $t('lower-price-slippage-and-cost-of-trading') }}
                </div>
                <div class="tw-flex tw-items-center tw-text-base md:tw-text-lg lg:tw-text-xl">
                  <SvgoCommonIconWallet
                    class="tw-w-4 md:tw-w-5 lg:tw-w-6 tw-h-4 md:tw-h-5 lg:tw-h-6 tw-mr-2 md:tw-mr-3 lg:tw-mr-5 xl:tw-mr-6"
                  />
                  {{ $t('transfer-large-fiat-sums-into-crypto-accounts') }}
                </div>
              </div>
            </div>
            <div class="tw-basis-full lg:tw-basis-5/12 tw-flex tw-justify-center tw-items-center">
              <NuxtImg alt="bank-service" src="/res/img/infrastructure/bank.png" class="tw-w-full tw-max-w-[400px]" />
            </div>
          </div>
        </section>
      </div>
    </section>

    <section class="tw-container tw-mx-auto">
      <div class="tw-rounded-2xl xl:tw-rounded-3xl tw-px-6 md:tw-px-8 lg:tw-px-10 tw-py-14 md:tw-py-18 lg:tw-py-20 xl:tw-py-24 tw-bg-[#111224]/[.02]">
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-5 md:tw-gap-10 lg:tw-gap-14 xl:tw-gap-20">
          <div class="tw-basis-full lg:tw-basis-1/2 lg:tw-order-2 tw-flex tw-flex-col tw-justify-center">
            <SvgoCommonIconCode class="tw-w-[100px]" />
            <i18n-t
              keypath="built-for-your-native-mobile-app"
              tag="h2"
              class="tw-text-3xl lg:tw-text-5xl xl:tw-text-6xl tw-mt-5 tw-font-medium tw-leading-normal lg:!tw-leading-none"
            >
              <br />
              <br />
            </i18n-t>
            <p class="tw-text-base md:tw-text-lg lg:tw-text-xl tw-mt-5 md:tw-mt-6 lg:tw-mt-8 xl:tw-mt-10 !tw-leading-normal">
              {{
                $t(
                  'our-payments-products-are-built-to-unite-your-business-we-support-all-kinds-of-platforms-including-web-and-mobile-for-an-ultimate-experience',
                )
              }}
            </p>
          </div>
          <div class="tw-basis-full lg:tw-basis-1/2 lg:tw-order-1">
            <div class="tw-flex tw-justify-center lg:tw-justify-between tw-gap-4">
              <div class="tw-flex-1">
                <NuxtImg alt="example-1" src="/res/img/infrastructure/example-1-1.png" />
              </div>
              <div class="tw-flex-1">
                <NuxtImg alt="example-2" src="/res/img/infrastructure/example-2-1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="tw-container tw-mx-auto">
      <PartnerShipsBuildWithUs />
    </section>
  </section>
</template>
<script setup lang="ts">
  import { cloneDeep } from 'lodash-es'
  const that: any = getCurrentInstance()

  const animation = ref()

  const zenDesk = useZenDesk()
  const onTouched = () => {
    zenDesk.onToggle()
  }
  const scrollToView = () => {
    that.refs.potential.scrollIntoView({ behavior: 'smooth' })
  }

  onMounted(async () => {
    const [lottie, AnimationData] = await Promise.all([import('lottie-web'), import('@/assets/animation/animation.json')])
    animation.value = lottie.default.loadAnimation({
      container: that.refs.lottie_box as HTMLDivElement,
      renderer: 'svg',
      loop: true,
      animationData: cloneDeep(AnimationData.default),
    })
  })

  onUnmounted(() => {
    animation.value?.destroy?.()
    animation.value = {}
  })
  definePageMeta({
    middleware: ['sosovalue','ip2location'],
  })
</script>

<style scoped lang="scss">
  .section1 {
    position: relative;
    background: #03040a;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    overflow: hidden;

    .scroll {
      position: absolute;
      width: 100%;
      bottom: 100px;
    }

    .arrow {
      color: hsla(0, 0%, 100%, 0.2);
      position: relative;
      z-index: 999;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    &::before {
      content: '';
      background-image: linear-gradient(to bottom, rgba(3, 4, 10, 0) 0%, #03040a 88%);
      position: absolute;
      width: 100%;
      height: 60%;
      bottom: 0rem;
      left: 0;
      pointer-events: none;
      background-size: contain;
      z-index: 4;
    }

    &::after {
      content: '';
      background: url('/res/img/infrastructure/wide-bg.png') no-repeat 50% 50%;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0rem;
      left: 0;
      pointer-events: none;
      background-size: cover;
    }
  }

  .section2 {
    .chart {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &::after {
        content: '';
        width: 100%;
        height: 100%;
        pointer-events: none;
        background: url('/res/img/home/blue-line-graph.png') no-repeat 0 0;
        background-size: 100% 50%;
        margin: auto;
        position: absolute;
        left: 0;
        top: 10%;
      }

      #lottie_box {
        position: relative;
        z-index: 1;
      }
    }
  }

  .section3 {
    &__bg {
      position: relative;

      .left {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
      }

      .right {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
      }
    }
  }

  .section5 {
    position: relative;
    min-height: 215px;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 215px;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      background: url('/res/img/shadowbg/chartline-gold.svg') no-repeat 50% 50%;
      background-size: auto;
      pointer-events: none;
    }
  }
  .desktop {
    background-image: url('/res/img/cases/kucoin-desktop.png');
    background-repeat: no-repeat;
    position: relative;
  }
</style>
